import { tx as translateInterfaceText } from '@/utils/i18n';
import { useLanguage } from '@/hooks/useLanguage';
import React from 'react';
import { integrationsDataCards } from '@/data/integrationsData';

export function VSLeadsIntegrationsTest() {
  useLanguage();
  console.log('=== VSLeadsIntegrationsTest RENDERIZANDO ===');
  console.log('integrationsDataCards:', integrationsDataCards);

  return (
    <div className="py-6">
      <h2 className="text-2xl font-bold mb-4">{translateInterfaceText("Teste de Integrações")}</h2>

      <div className="space-y-4">
        <div className="bg-yellow-100 p-4 rounded">
          <p className="font-bold">{translateInterfaceText("Total de integrações:")}{" "}{integrationsDataCards.length}</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {integrationsDataCards.map((integration, index) => (
            <div
              key={integration.nameId}
              className="bg-white border-2 border-blue-500 rounded-lg p-4"
            >
              <div className="bg-gray-200 w-16 h-16 mb-2 flex items-center justify-center">
                {integration.logo ? (
                  <img
                    src={integration.logo}
                    alt={integration.name}
                    className="w-full h-full object-contain"
                    onError={(e) => {
                      console.error('Erro ao carregar imagem:', integration.name);
                      (e.target as HTMLImageElement).src = 'data:image/svg+xml,%3Csvg xmlns="http://www.w3.org/2000/svg" width="100" height="100"%3E%3Crect fill="%23ddd" width="100" height="100"/%3E%3Ctext x="50%25" y="50%25" text-anchor="middle" dy=".3em"%3E?%3C/text%3E%3C/svg%3E';
                    }}
                  />
                ) : (
                  <span className="text-4xl">{index + 1}</span>
                )}
              </div>
              <h3 className="font-bold text-lg">{integration.name}</h3>
              <p className="text-sm text-gray-600 line-clamp-2">{integration.description}</p>
              <p className="text-xs text-gray-400 mt-2">{translateInterfaceText("ID:")}{" "}{integration.nameId}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
